import React from "react";
import useVerifiedEnsName from "../../hooks/useVerifiedEnsName";
import { formatWalletAddress } from "../../utils/walletDisplay";

export default function WalletDisplay({
  address,
  fallback,
  className = "",
  showEnsBadge = true,
  title,
}) {
  const { displayName, ensName, isEnsVerified, isLoading } = useVerifiedEnsName(address);
  const fallbackName = fallback || formatWalletAddress(address);
  const visibleName = isEnsVerified ? displayName : fallbackName;
  const titleText =
    title ||
    (isEnsVerified
      ? `${ensName} resolves back to ${address}`
      : address || visibleName);

  return (
    <span
      className={`inline-flex min-w-0 max-w-full items-center gap-1.5 ${className}`}
      title={titleText}
      aria-label={titleText}
    >
      <span className="truncate">{isLoading && !isEnsVerified ? fallbackName : visibleName}</span>
      {isEnsVerified && showEnsBadge && (
        <span className="shrink-0 rounded-full bg-blue-50 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-blue-600">
          ENS
        </span>
      )}
    </span>
  );
}
